import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  SignUp,
  User,
  UserResp,
  UserCreate,
  UserEditReq,
  UserNamesResp,
  UserPagination,
} from 'src/app/models/user/user.model';
import { environment } from 'src/environments/environment';
import { Observable,throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient) {}

  public registerUser(signUp: SignUp) {
    return this.http.post<User>(`${environment.apis.user.SIGN_UP}`, signUp);
  }

  public listNamesUserService(idCompany: string, idLocation: string) {
    return this.http.get<UserNamesResp>(`${environment.apis.user.GET_NAMES}`, {
      params: {
        idCompany,
        idLocation,
      },
    });
  }

  public searchUser(
    idCompany: string,
   // idLocation: string,
    search: string,
    pageNumber: number,
    pageSize: number
  ) {
    const urlApi=`${environment.apis.user.SEARCH}`;
    return this.http.get<UserPagination>(urlApi, {
      params: {
        idCompany,
      //  idLocation,
        search,
        pageNumber,
        pageSize,
      },
    });
  }

  public getUserService(idUser: string) {
    return this.http.get<UserResp>(
      `${environment.apis.user.GET}/${idUser}`
    );
  }
  
  updateUser(user: UserEditReq): Observable<any>  {
    const urlApi=`${environment.apis.user.PUT}`;
    return this.http.put<void>(urlApi, user)
    .pipe(
      catchError(error=>{
        if(error.status===502){
          window.location.reload();
        }else{
          console.error("Back: ", error);
        }
        return throwError(error);
      }
      ));
  }

  // public updateUser(user: UserEditReq) {
  //   return this.http.put<void>(`${environment.apis.user.PUT}`, user);
  // }

  public createUser(user: UserCreate) {
    return this.http.post<void>(`${environment.apis.user.POST}`, user);
  }
}
